import React, { FC } from 'react'
import { TypeNewForm, TypeNewFormProps } from '../common/newType'

type ProductNewTypeFormProps = Omit<TypeNewFormProps, 'placeholder'>

export const BuildingTypeNewForm: FC<ProductNewTypeFormProps> = (props) => {
  return <TypeNewForm {...props} placeholder="New Building Type Name" />
}
